import { useQuery, UseQueryOptions } from 'react-query';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';
import { Guid } from '../../models';

export function useStandardNdaQuery(
	dataRoomGuid: Guid | undefined,
	companyName: string | undefined,
	options?: Omit<UseQueryOptions<string, unknown, string, any>, 'queryKey' | 'queryFn'>
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Nda.Standard(dataRoomGuid, companyName),
		() =>
			AxiosUtils.getResponseData<string>(
				api.get(
					CerebroApiEndpoints.Nda.Standard(dataRoomGuid!, companyName!),
					{ responseType: 'text' }
				)
			),
		{
			enabled: !!dataRoomGuid && !!companyName,
			retry: false,
			...options,
		}
	);
}
